module.exports = __webpack_public_path__ + "img/NewsSection_Mobile.226a25ae.png";